import Sentry from "@similarweb/sentry-logger";

import { allTrackers } from "app/services/track/track";
const getError = (error: string | Error | null): Error => {
    if (error instanceof Error) {
        return error;
    } else if (typeof error === "string") {
        return new Error(error);
    } else {
        return new Error("Unknown error occurred");
    }
};
export const logErrorToSentry = (message: string, error: Error | string, extraData = {}) => {
    Sentry.error(message, getError(error), {
        extra: {
            ...extraData,
            team: "Unicorns",
            feature: "SEO Agent",
        },
    });
};

export const logErrorToTrackers = (errorType: string, error: Error | string) => {
    allTrackers.dispatchTrackEvent("Button", "click", `SEO Agent/Error/${errorType}`, {
        errorMessage: getError(error).message,
    });
};
